import { Flex, Input } from '@chakra-ui/react'
import * as T from '../../../../../../components/Table'
import { Controller, useFormContext } from 'react-hook-form'

export function ReferenteItem({ item, control, isDisabled }) {
  const { formState } = useFormContext()
  const hasError = formState?.errors?.items?.[item.id_vendedor]?.valor

  return (
    <T.Tr>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important">
        {item.gasto}
      </T.Td>
      <T.Td p={1} borderRight="1px solid #cfcfcf!important" w="300px">
        <Flex mx="auto" alignItems="center" justifyContent="center">
          <Controller
            rules={{ required: 'Campo obrigatório' }}
            name={`items[${item.id_vendedor}].valor`}
            defaultValue={item.original_valor}
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                type="number"
                w="100%"
                textAlign="center"
                placeholder="R$ 0,00"
                bg="white"
                size="xs"
                isDisabled={item.vendedor}
                //se tiver erros, borda vermelha
                borderColor={hasError ? 'red.500' : 'gray.300'}
              />
            )}
          />

          <Controller
            name={`items[${item.id_vendedor}].numero_nota`}
            defaultValue={item.numero_nota}
            control={control}
            render={({ field }) => <Input {...field} type="hidden" />}
          />

          <Controller
            name={`items[${item.id_vendedor}].id_vendedor`}
            defaultValue={item.id_vendedor}
            control={control}
            render={({ field }) => <Input {...field} type="hidden" />}
          />
        </Flex>
      </T.Td>
      <T.Td p={1}>{item.deducao}</T.Td>
    </T.Tr>
  )
}
